// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';
import massLaborRate from '../state/mass-labor-rates';

const setLaborRate = (state, action) =>
    massLaborRate.update(state, {
        $set: action.data
    });

const updateEffectiveDate = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.overrideEffectiveDate = action.date;
        return account;

    });

    return massLaborRate.update(state, {
        $set: updatedLaborRateList
    });

};

const updateInternalDeereComments = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.internalDeereComments = action.data;
        return account;

    });

    return massLaborRate.update(state, {
        $set: updatedLaborRateList
    });

};

const updateCommentsToDealer = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.notesToDealer = action.data;
        return account;

    });

    return massLaborRate.update(state, {
        $set: updatedLaborRateList
    });

};

const updateReasonForOverride = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.reasonForOverride = action.reason;
        return account;

    });

    return massLaborRate.update(state, {
        $set: updatedLaborRateList
    });

};

const updateStatus = (state, action) => {

    const updatedLaborRateList = state.map(account => {

        account.requestStatus.key = action.data;
        account.requestStatus.value = action.data;
        return account;

    });

    return massLaborRate.update(state, {
        $set: updatedLaborRateList
    });

};

export default (state = getDefaultState().laborRate, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_LABOR_RATE_CHANGES_FOR_ACCOUNT]: setLaborRate,
        [actions.UPDATE_TCSM_LABOR_RATE_COMMENTS_TO_DEALER]: updateCommentsToDealer,
        [actions.UPDATE_TCSM_LABOR_RATE_INTERNAL_DEERE_COMMENTS]: updateInternalDeereComments,
        [actions.UPDATE_TCSM_LABOR_RATE_REASON_FOR_OVERRIDE]: updateReasonForOverride,
        [actions.UPDATE_TCSM_LABOR_RATE_OVERRIDE_EFFECTIVE_DATE]: updateEffectiveDate,
        [actions.UPDATE_TCSM_LABOR_RATE_STATUS]: updateStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/reducers/labor-rate.js